import { call, put, takeLatest } from 'redux-saga/effects';
import { API_FAVORITE, API_LIST_FAVORITE } from '../api';
import API from 'core/networks/API';
import { AxiosResponse } from 'axios';
import { UPDATE_FAVORITE_REQUEST, FETCH_LIST_FAVORITE_REQUEST, updateFavoriteError, updateFavoriteSuccess, fetchListFavoriteError, fetchListFavoriteSuccess } from './actions';
import { route } from 'core/router';

function* getListfavorite(_action: any) {
    try {
        const data = _action?.payload || {};
        const response: AxiosResponse = yield call(API.get, API_LIST_FAVORITE, data);
        yield put(fetchListFavoriteSuccess(response.data));
    } catch (error) {
        yield put(fetchListFavoriteError(error as Error));
    }
}

function* favorite(_action: any) {
    try {
        const { id, ...data } = _action.payload || {};
        const url  =  route(API_FAVORITE, id)
        const response: AxiosResponse = yield call(API.post, url, data);
        yield put(updateFavoriteSuccess(response.data.data));
    } catch (error) {
        yield put(updateFavoriteError(error as Error));
    }
}


export default function* FavoriteSaga() {
    yield takeLatest(FETCH_LIST_FAVORITE_REQUEST, getListfavorite);
    yield takeLatest(UPDATE_FAVORITE_REQUEST, favorite);
}

